import { render, staticRenderFns } from "./dialog-box.component.vue?vue&type=template&id=deb8e964&scoped=true"
import script from "./dialog-box.component.vue?vue&type=script&lang=js"
export * from "./dialog-box.component.vue?vue&type=script&lang=js"
import style0 from "./dialog-box.component.vue?vue&type=style&index=0&id=deb8e964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb8e964",
  null
  
)

export default component.exports